
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import NotFound from '../pages/NotFound';
import WhyInvestRuralSouthAfricaPage from '../pages/research/why-invest-rural-south-africa/page';
import AfricanUrbanisationChallengesPage from '../pages/research/african-urbanisation-challenges/page';
import RuralAfricaPotentialPage from '../pages/research/rural-africa-potential/page';
import UnderstandingRuralSpacesAfricaPage from '../pages/research/understanding-rural-spaces-africa/page';
import RuralDevelopmentLandOwnershipPage from '../pages/research/rural-development-land-ownership/page';
import RuralGroceryStoreDevelopmentPage from '../pages/research/rural-grocery-store-development/page';
import SmartVillagesPage from '../pages/smart-villages/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/research/why-invest-rural-south-africa',
    element: <WhyInvestRuralSouthAfricaPage />
  },
  {
    path: '/research/african-urbanisation-challenges',
    element: <AfricanUrbanisationChallengesPage />
  },
  {
    path: '/research/rural-africa-potential',
    element: <RuralAfricaPotentialPage />
  },
  {
    path: '/research/understanding-rural-spaces-africa',
    element: <UnderstandingRuralSpacesAfricaPage />
  },
  {
    path: '/research/rural-development-land-ownership',
    element: <RuralDevelopmentLandOwnershipPage />
  },
  {
    path: '/research/rural-grocery-store-development',
    element: <RuralGroceryStoreDevelopmentPage />
  },
  {
    path: '/smart-villages',
    element: <SmartVillagesPage />,
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
